import { render, staticRenderFns } from "./BogoConfigTab.vue?vue&type=template&id=30f92936&scoped=true&"
import script from "./BogoConfigTab.vue?vue&type=script&lang=js&"
export * from "./BogoConfigTab.vue?vue&type=script&lang=js&"
import style0 from "./BogoConfigTab.vue?vue&type=style&index=0&id=30f92936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f92936",
  null
  
)

export default component.exports